import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { ApiRequestOptions } from '../Interfaces/api-request-options.interface';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  private readonly _http = inject(HttpClient);
  private readonly _host = environment.coreApi.host;

  get<T>(resource: string, options: ApiRequestOptions = {}): Observable<T> {
    return this._http.get<T>(this.buildUrl(resource), {
      headers: this.buildHeaders(options),
    });
  }

  post<T>(resource: string, body: unknown = {}, options: ApiRequestOptions = {}): Observable<T> {
    return this._http.post<T>(this.buildUrl(resource), body, {
      headers: this.buildHeaders(options),
    });
  }

  put<T>(resource: string, body: unknown = {}, options: ApiRequestOptions = {}): Observable<T> {
    return this._http.put<T>(this.buildUrl(resource), body, {
      headers: this.buildHeaders(options),
    });
  }

  patch<T>(resource: string, body: unknown = {}, options: ApiRequestOptions = {}): Observable<T> {
    return this._http.patch<T>(this.buildUrl(resource), body, {
      headers: this.buildHeaders(options),
    });
  }

  delete<T>(resource: string, options: ApiRequestOptions = {}): Observable<T> {
    return this._http.delete<T>(this.buildUrl(resource), {
      headers: this.buildHeaders(options),
    });
  }

  private buildUrl(resource: string): string {
    const cleanResource = resource.startsWith('/') ? resource.substring(1) : resource;
    return `${this._host}/${cleanResource}`;
  }

  private buildHeaders(options: ApiRequestOptions): HttpHeaders {
    let headers = new HttpHeaders(options.headers ?? {});

    if (options.skipLoading) {
      headers = headers.set('skip-loading', 'true');
    }

    return headers;
  }
}
